var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Cliente (Nome ou Telefone)"},model:{value:(_vm.clienteSelecionado),callback:function ($$v) {_vm.clienteSelecionado=$$v},expression:"clienteSelecionado"}})}
var staticRenderFns = []

export { render, staticRenderFns }